import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WorkOrderAttachmentsSurface } from './WorkOrderAttachmentsSurface';
export { WorkOrderAttachmentsSurface };
/**
 * `WorkOrderAttachments` — the composition root, mounted by `react_component` from the work order
 * show page when `new_attachment_direct_uploads_enabled?` is true.
 * `WorkOrderAttachmentsSurface` configures the shared `@features/Attachments` surface; this
 * wrapper's own job is only the `QueryClientProvider` every mounted island owns for itself
 * (mirrors `BuildingAttachments` and `InspectionAttachments`).
 */
function WorkOrderAttachments(props) {
    const queryClient = useMemo(() => new QueryClient(), []);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(WorkOrderAttachmentsSurface, Object.assign({}, props))));
}
export default WorkOrderAttachments;
